import httpClient from "services/network/httpClient";

export interface CompanyDetailsProps {
    id?: number;
    companyName: string;
    logoKey?: string;
    logoUrl?: string;
}
export type CompanyFormValues = {
    companyName: string;
    logo: FileList;
};
export const getUploadUrl = async (fileName: string) => {
    const response: any = await httpClient.post("/upload-url", {
        fileName,
    });
    console.log("Upload For Presigned URL:", response);
    console.log("Upload For Presigned URL:", response.value);
    return response.value;
};

export const uploadFileToS3 = async (
    presignedUrl: string,
    file: File
) => {
    const response = await fetch(presignedUrl, {
        method: "PUT",
        headers: {
            "Content-Type": file.type, // must match backend
        },
        body: file, // raw binary
    });

    if (!response.ok) {
        const text = await response.text();
        console.error("Upload failed:", text);
        throw new Error("S3 upload failed");
    }

    return response;
};

export const updateCompanySettings = async (data: any) => {
    const response: any = await httpClient.post(
        "/company-settings",
        data,
    );
    return response.data;
};

export const createCompanySettings = async (data: any) => {
    const response: any = await httpClient.post(
        "/company-settings",
        data
    );
    return response.data;
};